import T from 'prop-types';
import {
  FaUser,
  FaSignOutAlt
} from 'react-icons/fa';
import {color} from './style';
import { Button, Menu } from '@oliasoft-open-source/react-ui-library';

export const UserMenu = ({
  userName = '',
  navToUserProfile,
  onClickLogOut
}) => {
  const initials = userName
    .split(' ')
    .filter((v) => v)
    .map((v) => v[0].toUpperCase())
    .join('');

  const name = userName.split(' ').join('').length < 35
    ? userName
    : userName.split(' ').slice(0, 3).join(' ');

  const userMenu = [
    {
      type: 'Heading',
      label: name,
    },
    {
      type: 'Option',
      label: 'Profile',
      icon: <FaUser color={color} />,
      onClick: navToUserProfile,
    },
    { type: 'Divider' },
    {
      type: 'Option',
      label: 'Sign out',
      icon: <FaSignOutAlt color={color} />,
      onClick: onClickLogOut,
    },
  ];

  return (
    <Menu
      menu={{
        trigger: 'Component',
        placement: 'bottom-end',
        component: <Button label={initials} colored round />,
        sections: userMenu,
      }}
    />
  );
};

UserMenu.propTypes = {
  userName: T.string,
  navToUserProfile: T.func.isRequired,
  onClickLogOut: T.func.isRequired
};
